import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './localization.routing';
import {NgaModule} from '../../theme/nga.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {LocalizationComponent} from './localization.component';

import {SectorsComponent} from './components/sectors/sectors.component';
import {SectorList} from './components/sectors/components/list/list.component';
import {SectorForm} from './components/sectors/components/form/form.component';

import {SectorTypesComponent} from './components/sector-types/sector-types.component';
import {SectorTypeList} from './components/sector-types/components/list/list.component';
import {SectorTypeForm} from './components/sector-types/components/form/form.component';

import {SectorCategoriesComponent} from './components/sector-categories/sector-categories.component';
import {SectorCategoryList} from './components/sector-categories/components/list/list.component';
import {SectorCategoryForm} from './components/sector-categories/components/form/form.component';

import {SubCountiesComponent} from './components/sub-counties/sub-counties.component';
import {SubCountyList} from './components/sub-counties/components/list/list.component';
import {SubCountyForm} from './components/sub-counties/components/form/form.component';

import {ConstituenciesComponent} from './components/constituencies/constituencies.component';
import {ConstituencyList} from './components/constituencies/components/list/list.component';
import {ConstituencyForm} from './components/constituencies/components/form/form.component';

import {CountiesComponent} from './components/counties/counties.component';
import {CountyList} from './components/counties/components/list/list.component';
import {CountyForm} from './components/counties/components/form/form.component';

import {PopulationGroupComponent} from './components/population-group/population-group.component';
import {PopulationGroupList} from './components/population-group/components/list/list.component';
import {PopulationGroupForm} from './components/population-group/components/form/form.component';

import {WardList} from "./components/wards/components/list";
import {WardForm} from "./components/wards/components/form";
import {WardComponent} from "./components/wards/ward.component";


@NgModule({
  imports: [
    CommonModule,
    NgaModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    routing
  ],
  declarations: [LocalizationComponent, SectorsComponent, CountiesComponent, SubCountiesComponent, ConstituenciesComponent, SectorList, SectorForm, CountyList, CountyForm, SubCountyList, SubCountyForm, ConstituencyList, ConstituencyForm, PopulationGroupComponent, PopulationGroupList, PopulationGroupForm, SectorTypesComponent, SectorTypeList, SectorTypeForm, SectorCategoriesComponent, SectorCategoryForm, SectorCategoryList,WardList,WardForm,WardComponent],
})
export class LocalizationModule {

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/localization.module.ts